import React from 'react';
import { BadgeAvatarView } from './BadgeAvatar.view';
import { mediaDir } from '../../../../appolloConfig';
import { UserPosition } from '../../../../types/leaderboard/leaderboard';
import { ProfileInfo } from '../../../../types/user/user.def';
import { QueryUserAccountQuery } from '../../../../graphql/generated/graphql';

interface BadgeAvatarProps {
  user: UserPosition | ProfileInfo | QueryUserAccountQuery['getUserAccount'];
  variant: 'leaderboard' | 'profile';
}

export const BadgeAvatar = ({ user, variant }: BadgeAvatarProps) => {
  const source = user?.avatar?.media?.url && mediaDir + user.avatar?.media?.url;

  return (
    <BadgeAvatarView
      prenom={user?.firstname}
      nom={user?.lastname}
      ville={user?.ville}
      variant={variant}
      source={source}
      username={user?.username}
    />
  );
};
